import React, { useEffect, useState } from "react";
import axios from 'axios';
import './Main.css';
import './Home.css';
import TopNav from './TopNav';
import MainNav from './MainNav';
import LoginCheck from '../util/LoginCheck';
import DecodeData from '../util/DecodeData';
import LoginFail from '../util/LoginFail';
import BillboardChart from "react-billboardjs";
import "react-billboardjs/lib/billboard.css";
import SelectCenter from "../util/SelectCenter";
import { useSelector, useDispatch } from 'react-redux';
import {
    DatePicker
} from 'antd';
import GetApiHost from '../util/GetApiHost';
import moment from 'moment';

var dateArray = [""];

let axis = {
    x: {
      type: "category",
      categories: [
        '베이직',
        '아이언',
        '브론즈',
        '실버',
        '골드',
        '플래티넘',
        '다이아',
        '마스터',
        '그랜드마스터',
        '챌린저',
        '레전드'
      ]
    }
}

let defaultData = {
    columns: [
      dateArray
    ],
    type: "bar",
    labels : true
  };


export default function Home() {
    const [chartData, setChartData] = useState(defaultData);;
    const [selectedCenter, setSelectedCenter ] = useState('');
    const [tdate, setTDate] = useState(moment().format('YYYY-MM-DD'));
    const data = useSelector(state => state.data);
    const dispatch = useDispatch();

    function handleSelectedCenter(centerId){
        setSelectedCenter(centerId);
    }

    async function getChartInfo(){
        var temp_cid = '';
        if(data.cid !== 'root'){
            temp_cid = data.cid
        }else{
            temp_cid = selectedCenter
        }

        const api_host = GetApiHost();
        const result = await axios.post(api_host + '/hg_admin/level_chart', {
            cid : temp_cid,
            tdate : tdate
        })
        if(result.data.ret == 'Y'){
            dateArray = ["레벨"];
            console.log(result.data.rows);
            result.data.rows.map((count) => dateArray.push(count.count))
            setChartData({
                columns: [
                    dateArray
                ],
                type: "bar",
                labels : true
            });
        }else{
            alert(result.data.msg)
        }
    }


    const on_change_date = value => {
        setTDate(moment(value).format('YYYY-MM-DD'));
    }

    async function main() {
        const result = await LoginCheck(data.url);
        if(result === "Y"){
            const decodeResult = await DecodeData(data.url);
            dispatch({type:'SET', name:"CID", value:decodeResult.cid});
            dispatch({type:'SET', name:"LEVEL", value:decodeResult.level});
            getChartInfo();
        }else{
            LoginFail();
        }
    }

    useEffect(()=>{
        main();
    },[]);

    useEffect(()=>{
        if(data.cid === "root"){
            getChartInfo();
        }
    },[selectedCenter]);

    useEffect(()=>{
        getChartInfo();
    }, [tdate]);

    return (
        <main className="main-container">
            <TopNav />
            <div className="content-wrapper">
            <MainNav />
            <div className="content-inner home">
            <h3>레벨통계</h3>
            <div className="content-component">
                <SelectCenter 
                    onSelectedCenter={handleSelectedCenter}
                />
            <div className="level-chart-container">
                <div className="chart-date">
                    기준일자 : &nbsp;
                    <DatePicker
                        format="YYYY-MM-DD" 
                        onChange={on_change_date}
                        defaultValue={moment(moment(),'YYYY-MM-DD')}
                    >
                    </DatePicker>
                </div>
                    <BillboardChart data={chartData} axis={axis} />
            </div>
            </div>
            </div>
            </div>
        </main>
    )
}